export default __webpack_public_path__ + "static/media/regulatory--no-caravans-or-caravan-trailers--g1.ee733d20.png";